<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>edit</md-icon>
          </div>
          <h4 class="title">Update Product</h4>
        </md-card-header>

        <md-card-content>
          <md-field>
            <label>Title</label>
            <md-input v-model="name" type="text" required />
          </md-field>

          <md-field>
            <label>Slug</label>
            <md-input v-model="slug" type="text" required />
          </md-field>

          <md-field>
            <label>Description</label>
            <md-input v-model="shortDescription" type="text" required />
          </md-field>

          <md-field>
            <label>Price</label>
            <md-input v-model="price" type="number" required />
          </md-field>

          <md-field>
            <label>Offer Price</label>
            <md-input v-model="offerPrice" type="text" />
          </md-field>

          <md-field>
            <label>Offer Price Text</label>
            <md-input v-model="offerPriceText" type="text" />
          </md-field>

          <md-field>
            <label>Categories</label>
            <md-select v-model="selectedCategories" multiple>
              <md-option
                v-for="category in categories"
                :key="category._id"
                :value="category._id"
              >
                {{ category.title }}
              </md-option>
            </md-select>
          </md-field>

          <!-- Product Image (Optional) -->
          <div class="file-field">
            <label class="file-label">Product Image (optional)</label>
            <input type="file" @change="fileUpload($event)" />
          </div>
        </md-card-content>

        <md-card-actions md-alignment="left">
          <md-button class="md-success" :disabled="isDisabled" @click="updateProduct">
            Update
            <span v-if="isDisabled">
              <i class="fa fa-spinner fa-spin"></i>
            </span>
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import ProductService from "../../../services/ProductService";
import CategoryService from "../../../services/CategoryService";

export default {
  data() {
    return {
      isDisabled: false,
      productId: this.$route.params.id,

      name: "",
      slug: "",
      shortDescription: "",
      price: 0,
      offerPrice: "",
      offerPriceText: "",
      productImage: null,

      categories: [],
      selectedCategories: []
    };
  },

  methods: {
    fileUpload(event) {
      this.productImage = event.target.files[0];
    },

    async updateProduct() {
      this.isDisabled = true;

      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("slug", this.slug);
      formData.append("shortDescription", this.shortDescription);
      formData.append("price", this.price);
      formData.append("offerPrice", this.offerPrice);
      formData.append("offerPriceText", this.offerPriceText);

      if (this.productImage) {
        formData.append("productImage", this.productImage);
      }

      this.selectedCategories.forEach((catId) => {
        formData.append("categories[]", catId);
      });

      try {
        const response = await ProductService.updateProduct(this.productId, formData);
        this.$toast.success(response.data.respones_msg);
        this.$router.push("/products");
      } catch (e) {
        this.$toast.error(e.response.data.respones_msg);
      } finally {
        this.isDisabled = false;
      }
    },

    async getProduct() {
      const response = await ProductService.getProductDetail(this.productId);
      const product = response.data.data;

      this.name = product.name;
      this.slug = product.slug;
      this.shortDescription = product.shortDescription;
      this.price = product.price;
      this.offerPrice = product.offerPrice;
      this.offerPriceText = product.offerPriceText;
      this.selectedCategories = product.categories.map(c => c._id);
    },

    async getCategories() {
      const response = await CategoryService.getCategories();
      this.categories = response.data.data;
    }
  },

  watch: {
    name(val) {
      this.slug = val
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");
    }
  },

  async beforeMount() {
    await this.getCategories();
    await this.getProduct();
  }
};
</script>

<style scoped>
.file-field {
  margin-top: 15px;
}
.file-label {
  display: block;
  font-size: 14px;
  margin-bottom: 6px;
}
</style>
